import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
// import moment from 'moment';
import moment from 'moment-timezone';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withOnline from '../../common/withOnline';
import withSingleScanSession from '../../common/withSingleScanSession';
import withScanInventory from '../../common/withScanInventory';
import Header from '../../components/Header';
import {
  getSyncInventoryDate,
  onGoBack,
  storeSyncInventoryDate,
  storeLastVisitedRoute,
  getStoreLastVisitedRoute,
  storeInventoryFlag,
  getInventoryFlag
} from '../../common/globals';
import InventoryInfo from '../../components/Models/InventoryInfo';
import Bugsnag from '../../helpers/bugsnag';
import { getInventoryData } from '../../utils/utils';
import {
  setInventoryData,
  getInventory,
  deleteByPrimaryKey
} from '../../utils/db';
import withTeam from '../../common/withTeam';

class Inventory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scanDate: '',
      localScanDate: ''
    };
    this.inventoryInfoModal = null;
  }

  async componentDidMount() {
    try {
      this.inventoryInfoModal = new window.bootstrap.Modal(window.$('#inventoryInfoModal'));
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onInfo = () => {
    try {
      this.inventoryInfoModal.show();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onViewInventory = () => {
    try {
      setTimeout(async () => {
        await this._onSevenDayOldInventory();
      }, 1000);
      this._onGoBack();
      storeLastVisitedRoute('view-inventory');
      browserHistory.push('/inventory/consignment/view-inventory');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onScanSession = () => {
    try {
      setTimeout(async () => {
        await this._onSevenDayOldInventory();
      }, 1000);
      this._onGoBack();
      const { setScanInventory } = this.props;
      setScanInventory({});
      storeLastVisitedRoute('scan-session');
      browserHistory.push('/inventory/consignment/scan-session');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onManageScanSession = () => {
    try {
      setTimeout(async () => {
        await this._onSevenDayOldInventory();
      }, 1000);
      const { setSingleScanSession } = this.props;
      setSingleScanSession({});
      this._onGoBack();
      storeLastVisitedRoute('manage-sessions');
      browserHistory.push('/inventory/consignment/manage-sessions');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  _onGoBackInventory = () => {
    try {
      const { goBack } = this.props;
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSyncInventory = async () => {
    try {
      const { online, setLoader } = this.props;
      const { scanDate } = this.state;
      if (online) {
        setLoader(true);
        const inventoryDataRes = await getInventoryData({ payload: 'DATA' });
        const { data } = inventoryDataRes;
        if (inventoryDataRes.hasOwnProperty('data')) {
          await setInventoryData(data);
          await storeSyncInventoryDate(scanDate);
          storeInventoryFlag('false');
          this.setState({
            localScanDate: scanDate
          });
        } else {
          // notify({ type: 'error', message });
          storeInventoryFlag('true');
          this.setState({ noInventoryData: true });
        }
        // setLoader(false);
      }
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSevenDayOldInventory = async () => {
    try {
      const getInventoryByAccountNameRes
        = await getInventory();
      const scanSessionRes = getInventoryByAccountNameRes.reduce((session, value) => {
        const key = value.SessionID;
        if (session[key] == null) session[key] = [];
        value.sessionNameWithId = value.SessionName === '' ? value.SessionID
          : `${value.SessionName}(${value.SessionID})`;
        session[key].push({
          sessionNameWithId: value.sessionNameWithId,
          SessionName: value.SessionName,
          SessionID: value.SessionID,
          Submitted: value.Submitted,
          id: value.inventoryId,
          ScanDate: value.ScanDate
        });
        return session;
      }, {});
      Object.keys(scanSessionRes).map(async (data) => {
        let sevenDaysOld = [];
        const deleteDataPromiseAll = scanSessionRes[data].map(
          // eslint-disable-next-line no-async-promise-executor
          (value) => new Promise(async (resolve) => {
            resolve(true);
            const toDay = new Date();
            toDay.setDate(toDay.getDate() - 7);
            if (moment(value.ScanDate).format('YYYY-MM-DD') < moment(toDay).format('YYYY-MM-DD')) {
              sevenDaysOld.push(true);
            } else {
              sevenDaysOld.push(false);
            }
          })
        );
        await Promise.all(deleteDataPromiseAll);
        if (sevenDaysOld.every((item) => item === true)) {
          scanSessionRes[data].map(async (item) => {
            await deleteByPrimaryKey(item.id);
          });
        }
        sevenDaysOld = [];
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        online, setLoader, notify
      } = this.props;
      const syncDate = await getSyncInventoryDate();
      const lastVisitedRoute = await getStoreLastVisitedRoute();
      const inventoryFlag = await getInventoryFlag();
      if (inventoryFlag === 'true') {
        this.setState({ noInventoryData: true });
      } else {
        this.setState({ noInventoryData: false });
      }

      if (online) {
        setLoader(true);
        const inventoryDataRes = await getInventoryData({ payload: 'DATE' });
        const { date, message } = inventoryDataRes;
        if (message === 'Inventory retrived successsfully') {
          this.setState({
            scanDate: date,
            noInventoryData: false,
            localScanDate: date
          }, () => {
            storeInventoryFlag('false');
          });
        } else {
          this.setState({ noInventoryData: true }, () => {
            storeInventoryFlag('true');
          });
          // notify({ type: 'error',
          // message: 'Please click on Sync to enable Scan Inventory', time: 3 });
        }
        // setLoader(false);
      } else if (lastVisitedRoute === 'consignment') {
        notify({
          type: 'error',
          message: 'You must have an internet connection. Please check your connection and try again.',
          time: 5
        });
      }

      this.setState({ lastVisitedRoute, localScanDate: syncDate });
      setLoader(false);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const {
      localScanDate, scanDate, lastVisitedRoute, noInventoryData
    } = this.state;

    const { online } = this.props;
    return (
      <section className="list-section resizer-class">
        <Header
          title="Consignment"
          goBack={this._onGoBackInventory}
          goForward={{
            title: '<i class="fas fa-info-circle"></i></a>',
            onGoForward: this._onInfo
          }}
        />
        <section className="billing-section resizer-class">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-md-6 sync-block">
                {
                  !online && lastVisitedRoute === 'consignment' && localScanDate !== ''
                    ? (
                      <p className="mb-0">{`Last Inventory Sync: ${localScanDate !== ''
                        // ? moment.tz(new Date(), 'America/New_York').format('MM/DD/YY HH:MM A')
                        ? moment(new Date()).format('MM/DD/YY HH:MM A')
                        : 'Never'}`}
                      </p>
                    )
                    : (
                      <p className="mb-0">{`Last Inventory Sync: ${localScanDate !== ''
                        // ? moment.tz(new Date(), 'America/New_York').format('MM/DD/YY HH:MM A')
                        ? moment(new Date(scanDate)).format('MM/DD/YY HH:MM A')
                        : 'Never'}`}
                      </p>
                    )
                }

                {
                  !online && lastVisitedRoute === 'consignment' && localScanDate !== ''
                    ? (
                      <p>{`(${localScanDate === ''
                        ? 'Data not available'
                        : new Date(localScanDate) < new Date(scanDate)
                          ? 'Newer data available'
                          : (localScanDate === scanDate)
                            ? 'Newer data not available'
                            : 'Data not available'})`}
                      </p>
                    )
                    : (
                      <p>{`(${scanDate === ''
                        ? 'Data not available'
                        : localScanDate === ''
                          ? 'Data not loaded'
                          : new Date(localScanDate) < new Date(scanDate)
                            ? 'Newer data available'
                            : 'Newer data not available'})`}
                      </p>
                    )
                }
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-12 col-md-6 sync-block">
                <div className="mb-4">
                  <p className="time">
                    <Link
                      className="btn btn-theme-alt btn-theme-outline-alt d-block"
                      onClick={this._onSyncInventory}
                    >
                      {
                        !online && localScanDate !== ''
                          ? (
                            <span className={`status ${localScanDate === ''
                              ? 'red'
                              : new Date(localScanDate) < new Date(scanDate)
                                ? 'yellow'
                                : localScanDate === scanDate
                                  ? 'green'
                                  : 'green'}`}
                            />
                          )
                          : (
                            <span className={`status ${localScanDate === ''
                              ? 'red'
                              : new Date(localScanDate) < new Date(scanDate)
                                ? 'yellow'
                                : localScanDate === scanDate
                                  ? 'green'
                                  : 'green'}`}
                            />
                          )
                      }
                      Sync Inventory
                    </Link>
                  </p>
                </div>
              </div>
            </div>
            <hr className="line-height" />
            <div className="row justify-content-center mt-2">
              <div className="col-12 col-md-6">
                <button
                  className="btn btn-theme-alt btn-theme-outline-alt d-block w-100"
                  onClick={this._onViewInventory}
                  disabled={(!online && localScanDate === '')
                    || (localScanDate === '' && noInventoryData === false)
                    || noInventoryData === true}
                // disabled={(localScanDate === '' || (!online && localScanDate === ''))}
                >View Inventory
                </button>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-12 col-md-6 mt-4">
                <button
                  className="btn btn-theme-alt btn-theme-outline-alt d-block w-100"
                  onClick={this._onScanSession}
                  disabled={(!online && localScanDate === '')
                    || (localScanDate === '' && noInventoryData === false)
                    || noInventoryData === true}
                // disabled={(localScanDate === '' || (!online && localScanDate === ''))}
                >Scan Inventory
                </button>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-12 col-md-6 mb-4 mt-4">
                <button
                  className="btn btn-theme-alt btn-theme-outline-alt d-block w-100"
                  onClick={this._onManageScanSession}
                  disabled={(!online && localScanDate === '')
                    || (localScanDate === '' && noInventoryData === false)
                    || noInventoryData === true}
                // disabled={(localScanDate === '' || (!online && localScanDate === ''))}
                >Manage Scan Sessions
                </button>
              </div>
            </div>
          </div>
        </section>
        <InventoryInfo />
      </section>
    );
  }
}

export default withScanInventory(
  withSingleScanSession(
    withOnline(
      withGoBack(
        withNotify(
          withLoader(
            withTeam(
              Inventory
            )
          )
        )
      )
    )
  )
);
